import { Row } from "react-table";
import { genericMemo } from "../../../../../../utils";
import { BodyRow, BodyRowProps } from "./BodyRow";

export type RowsProps<T extends object> = {
  page: Row<T>[],
  prepareRow: (row: Row<T>) => void,
  getRowProps?: (row: Row<T>) => Partial<BodyRowProps<T>> | undefined
};

export const BodyRows = genericMemo(
  <T extends object>({ page, getRowProps, prepareRow }: RowsProps<T>) => {
    return (
      <div>
        {page.map((row) => {
          prepareRow(row);
          const { key, style, ...restRowProps } = row.getRowProps();
          const customRowProps = getRowProps?.(row);
          return <BodyRow key={key} style={style} cells={row.cells} {...restRowProps} {...customRowProps} />;
        })}
      </div>);
  },
);

export default BodyRows;
